
import Vue, { PropOptions } from 'vue';
import { SelectOption } from '../types';

export default Vue.extend({
    name: 'PlanSelect',
    props: {
        value: {
            type: Object,
            default: () => null,
        } as PropOptions<SelectOption | null>,
    },
    data() {
        const planOptions: SelectOption[] = [
            {
                label: 'Coursera',
                value: 'coursera',
            },
        ];
        return {
            planOptions,
        };
    },
    mounted() {
        this.selectedPlanOption = this.value || this.planOptions[0];
    },
    computed: {
        selectedPlanOption: {
            get(): SelectOption | null {
                return this.value;
            },
            set(value: SelectOption) {
                this.$emit('input', value);
            },
        },
    },
});
